// This file maps state to stores, and also exposes a fetchData function to fetch all the
// data needed to render the smart component
import BotStore from '@src/store';

export const listenToStores = [BotStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    canViewEditSmartSkill: BotStore.canViewEditSmartSkill(),
  };
}

export { setCurrentScreen } from 'actions/StoryActions';
